import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("functionaryTypePlant"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("attendanceDate"),
            field: "Fecha de asistencia",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("nameScheduledTime"),
            field: 'Horario teórico',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("scheduledTime"),
            field: 'Horario programado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("scheduleType"),
            field: 'Tipo de horario',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("expectedEntry"),
            field: 'Entrada programada',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("realEntry"),
            field: 'Marca de asistencia',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("status"),
            field: 'Status',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.attendanceReport],
        config: {
            headerName: getLocalizedString("currentConsultationHour"),
            field: 'Hora de consulta (Actual)',
        }
    },
]